import { Component, OnInit } from '@angular/core';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { ColDef, GridApi } from 'ag-grid-community';
import { plmService } from '../../services/plm.services';
import { QmMatriz } from '../../models/qm-matriz.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-qm-matriz-historico',
  templateUrl: './qm-matriz-historico.component.html',
  styleUrls: ['./qm-matriz-historico.component.css']
})
export class QmMatrizHistoricoComponent implements OnInit {

  data: QmMatriz[] = [];
  loading = false;
  form: FormGroup;
  
  public frameworkComponents: any;
  public columnDefs: ColDef[] = [];
  public defaultColDef: ColDef;
  public gridApi: GridApi;
  public gridColumnApi: any;
  public textoBuscar: string;

  constructor(
    private fb: FormBuilder,
    private matrizQmService: plmService,
  ) { 
    this.form = this.fb.group({
      tipo:[{ value: '', disabled: true }],
      grupo:[{ value: '', disabled: true }],
      claseInspeccion:[{ value: '', disabled: true }],
      descripcionTipoMaterial:[{ value: '', disabled: true }],
      descripcionGrupo:[{ value: '', disabled: true }],
      descripcionMacrocategoria:[{ value: '', disabled: true }],
      gestionQm:[{ value: '', disabled: true }],
      especificacionRdl:[{ value: '', disabled: true }],
      instruccionProcesoClaseInsp03:[{ value: '', disabled: true }],
      operacionesQmClaseInsp03:[{ value: '', disabled: true }],
      aprovActivo:[{ value: '', disabled: true }],
      claveQm:[{ value: '', disabled: true }],
      tipoCoa:[{ value: '', disabled: true }],
      puntoInspeccion:[{ value: '', disabled: true }],
      tipoPuntoInspeccion:[{ value: '', disabled: true }],
      pm0001Cuantitativa:[{ value: '', disabled: true }],
      pm0002Cualitativa:[{ value: '', disabled: true }],
      pm0003Cuantitativa:[{ value: '', disabled: true }],
      pm0004Cualitativa:[{ value: '', disabled: true }],
      pm0005Cuantitativa:[{ value: '', disabled: true }],
      pm0006Cualitativa:[{ value: '', disabled: true }],
      claseUtilizacion:[{ value: '', disabled: true }],
      c1001A001:[{ value: '', disabled: true }],
      c1001A002:[{ value: '', disabled: true }],
      c1001A003:[{ value: '', disabled: true }],
      c1001A004:[{ value: '', disabled: true }],
      c1001A005:[{ value: '', disabled: true }],
      c1001A006:[{ value: '', disabled: true }],
      c1001A009:[{ value: '', disabled: true }],
      c1002A001:[{ value: '', disabled: true }],
      c1002A006:[{ value: '', disabled: true }],
      c1002A007:[{ value: '', disabled: true }],
      c1002A008:[{ value: '', disabled: true }],
      c1002A009:[{ value: '', disabled: true }],
      c2001A001:[{ value: '', disabled: true }],
      c2001A010:[{ value: '', disabled: true }],
      c3001A001:[{ value: '', disabled: true }],
      c3001A012:[{ value: '', disabled: true }],
      qm1001:[{ value: '', disabled: true }],
      qm1002:[{ value: '', disabled: true }],
      qm2001:[{ value: '', disabled: true }],
      qm3001:[{ value: '', disabled: true }],
      usuarioTransaccion:[{ value: '', disabled: true }],
      usuario:[{ value: '', disabled: true }],
      version:[{ value: '', disabled: true }],
      transaccion:[{ value: '', disabled: true }],
      fecha:[{ value: '', disabled: true }]
    });
  }

  ngOnInit(): void {
    this.loadData();
    this.cargarGridcomponent();
  }

  cargarGridcomponent() {
    this.frameworkComponents = { buttonRenderer: LfsaBotonEditarGridComponent };
    this.columnDefs = [
      { cellRenderer: 'buttonRenderer', cellRendererParams: { onClick: this.editRecord.bind(this), label: 'Ver' } },
      { field: 'version'},
      { field: 'transaccion' },
      { field: 'fecha',  cellRenderer: (data) => { return data.value ? formatDate(new Date(data.value), 'dd-MM-yyyy HH:mm:ss', 'en') : '' } },
      { field: 'usuario' },
      { field: 'tipo', sort: "asc" },
      { field: 'grupo', sort: "asc" },
      { field: 'claseInspeccion', sort: "asc"},
      { field: 'descripcionTipoMaterial' },
      { field: 'descripcionGrupo' },
      { field: 'descripcionMacrocategoria' },
      { field: 'gestionQm' },
      { field: 'especificacionRdl' },
      { field: 'instruccionProcesoClaseInsp03' },
      { field: 'operacionesQmClaseInsp03' },
      { field: 'aprovActivo' },
      { field: 'claveQm' },
      { field: 'tipoCoa' },
      { field: 'puntoInspeccion' },
      { field: 'tipoPuntoInspeccion' },
      { field: 'pm0001Cuantitativa' },
      { field: 'pm0002Cualitativa' },
      { field: 'pm0003Cuantitativa' },
      { field: 'pm0004Cualitativa' },
      { field: 'pm0005Cuantitativa' },
      { field: 'pm0006Cualitativa' },
      { field: 'claseUtilizacion' },
      { field: 'c1001A001' },
      { field: 'c1001A002' },
      { field: 'c1001A003' },
      { field: 'c1001A004' },
      { field: 'c1001A005' },
      { field: 'c1001A006' },
      { field: 'c1001A009' },
      { field: 'c1002A001' },
      { field: 'c1002A006' },
      { field: 'c1002A007' },
      { field: 'c1002A008' },
      { field: 'c1002A009' },
      { field: 'c2001A001' },
      { field: 'c2001A010' },
      { field: 'c3001A001' },
      { field: 'c3001A012' },
      { field: 'qm1001' },
      { field: 'qm1002' },
      { field: 'qm2001' },
      { field: 'qm3001' }
    ];

    this.defaultColDef = {
      filter    : true,
      //floatingFilter: true,
      resizable : true,
      sortable  : true,
      minWidth  : 110,
      flex      : 1,
    };

  }

  onQuickFilterChanged() {
    this.gridApi?.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  loadData() {
    this.loading = true;
    this.matrizQmService.getAllClasesInpeccionHistoria().subscribe(response => {
      this.data = response;
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  openModal() {
    document.getElementById('abrirModal')?.click();
  }

  closeModal() {
    document.getElementById('cerrarModal')?.click();
  }

  acciones(event) {
    if (event === 'regresar') {
      return this.closeModal();
    }
  }
  
  selectedRecord ;
  titleModal ;
  editRecord({ rowData }: { rowData: QmMatriz }) {
    this.selectedRecord = { ...rowData };
    this.form.reset();
    //this.form.enable();
    this.form.patchValue(rowData);
    this.titleModal = "Ver historico del registro";
    this.openModal();
  }

}
